import type { Theme } from '@mui/material';

export const styles = {
  inputField: (theme: Theme) => ({
    backgroundColor: theme.colors.white,
  }),
};
